import { createContext, useCallback, useContext, useMemo, useState } from "react";

const KEY = "fg_modality";
const Ctx = createContext(null);

export const MODALITIES = [
  { id: "competition", label: "Competition", desc: "Points, timers, bests, clan challenges and leaderboards. The regular game." },
  { id: "study", label: "Study", desc: "No points shown, no clock. Retry what you miss and review it at the end. Still earns coins." },
];

export function ModalityProvider({ children }) {
  const [modality, setState] = useState(() => (localStorage.getItem(KEY) === "study" ? "study" : "competition"));
  const setModality = useCallback((m) => {
    localStorage.setItem(KEY, m);
    setState(m);
  }, []);
  const value = useMemo(() => ({ modality, setModality, isStudy: modality === "study" }), [modality, setModality]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useModality = () => useContext(Ctx);
